import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getEmpProfileAlbumsApi } from "../../API/API";

function* getEmpAlbumsSaga(params) {
  try {
    const response = yield call(getEmpProfileAlbumsApi, params);
    yield put({
      type: types.GET_EMP_ALBUMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_EMP_ALBUMS_FAILURE, error });
  }
}

export function* watchGetEmpAlbumsSaga() {
  yield takeEvery(types.GET_EMP_ALBUMS_REQUESTED, getEmpAlbumsSaga);
}
